import { render, staticRenderFns } from "./barType.vue?vue&type=template&id=588da432&"
import script from "./barType.vue?vue&type=script&lang=js&"
export * from "./barType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports